type AuthDevice = any & {
  code: string;
  secret: string;
};

type AuthIdentity =
  | {
      token: string;
      user: {
        email: string;
        roles: string[];
        name: string;
        profile: {
          fullName: string;
        };
      };
      permissions: string[] | any;
      [key: string]: any;
    }
  | any;

type AuthLogin = {
  username: string;
  password: string;
};

enum AuthThirdPartyProviders {
  // eslint-disable-next-line no-unused-vars
  GOOGLE = 'google'
}

type AuthThirdPartyLogin = {
  /**
   * Indicates the provider to use for authentication.
   */
  provider: AuthThirdPartyProviders;
  /**
   * Indicates the necessary data for authentication.
   */
  payload: any;
};

type AuthProviderConfig = {
  /**
   * Indicates the API address to use for authentication.
   */
  apiUrl: string;
  /**
   * Indicates the storage to use for data persistence.
   */
  storage?: import('./common').IStorage;
};

type AuthRegisterRequest =
  | any
  | {
      name: string;
      email: string;
      password: string;
    };

type AuthRegisterResponse = import('./common').BaseResponse & {
  userId: string;
};

type UpdateProfileRequest = {
  name: string;
  [key: string]: any;
};

export type {
  AuthDevice,
  AuthIdentity,
  AuthLogin,
  AuthProviderConfig,
  AuthRegisterRequest,
  AuthRegisterResponse,
  AuthThirdPartyLogin,
  UpdateProfileRequest
};

export { AuthThirdPartyProviders };
